import { render, staticRenderFns } from "./PChart.vue?vue&type=template&id=baa2e53e&scoped=true&"
import script from "./PChart.vue?vue&type=script&lang=js&"
export * from "./PChart.vue?vue&type=script&lang=js&"
import style0 from "./PChart.vue?vue&type=style&index=0&id=baa2e53e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa2e53e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText,VCardTitle})
